import { render, staticRenderFns } from "./ExamFisicoTable.vue?vue&type=template&id=3641aa35"
import script from "./ExamFisicoTable.vue?vue&type=script&lang=js"
export * from "./ExamFisicoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports